<script setup lang="ts">

</script>

<template>
  <div class="boxall" style="height: 3rem">
<!--    <div class="boxall" style="height: 2.7rem">-->
    <div class="alltitle">热门借阅图书</div>
    <div class="ExpertList">
      <ul id="popular-book" ><!-- style="padding-inline-start: 0px"-->
      </ul>
    </div>
    <div class="allnav" id="echart2"></div>
    <div class="boxfoot"></div>
  </div>
</template>

<style scoped lang="scss">

</style>